<template>
  <div
    class="overlay overlay--opened"
    @keyDown.prevent="onKeyDown()"
    >
    <div class="overlay--image has-dark-background">
      <controllerGroup
        :isLoading="isLoading"
        :title="slideshowTitle"
        :currentIndex="currentIndex"
        :slideLength="slides.length"
        gtm="slideshow"
        @close="$emit('close')"
        @previous="previous()"
        @next="next()"
        />

      <div class="overlay__content-mask--upper">
        <div class="overlay__content-mask--lower--right">
          <div class="overlay__content-container spinner">
            <div class="overlay__content">
              <div
                id="overlay-top"
                :class="spinnerClass"
                >
                <picture class="picture--center">
                  <img
                    ref="slideImage"
                    :src="currentImage"
                    class="picture__img--scale"
                    data-overlay-image="true"
                    data-overlay-prevent-close="true"
                    data-prevent-context-menu="true"
                    data-toggle-controls="true"
                    draggable="false"
                    loading="lazy"
                    onerror="window.MoMA.onImageError(this, 1)"
                    @load="onImgLoad"
                  >
                </picture>
              </div>
              <slideTitle
                :title="slideTitle"
                />
              <section class="uneven-columns--overlay">
                <div class="uneven-columns__first" />
                <div class="uneven-columns__second">
                  <div
                    class="main-content"
                    data-overlay-prevent-close="true"
                    v-html="slideDescription"
                    />
                  <div class="overlay__caption">
                    <span
                      class="overlay__caption__text balance-text"
                      data-overlay-prevent-close
                      v-html="slideCaption"
                      />
                  </div>
                </div>
                <div
                  class="uneven-columns__third"
                />
              </section>
              <footerOverlay />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import controllerGroup from './controllers/controller-group.vue';
  import footerOverlay from '../installation-images-vue/footer-overlay.vue';
  import { MoMABalanceText } from 'sol';
  import slideMixins from "./mixins.js";
  import slideTitle from "./slides/slide-title.vue";

  export default {
    components: {
      controllerGroup,
      footerOverlay,
      slideTitle
    },

    mixins: [
      slideMixins
    ],

    props: {
      slideshowId: {type: Number, required: true },
      index: {type: Number, required: true },
    },

    data: function() {
      return {
        title: "",
        slides: [],
        isLoading: true,
        height: 0,
        width: 0,
        currentIndex: this.index,
        imageLoaded: false,
        balanceText: new MoMABalanceText(),
      };
    },

    computed: {
      hasPreviousSlide() {
        return !this.isLoading && this.currentIndex > 0 ;
      },

      hasNextSlide() {
        return !this.isLoading && (this.currentIndex < this.slides.length - 1);
      },

      slideTitle() {
        if (!this.isLoading) {
          // note: <em> here is to negate the ems' coming from tms data
          return `<em>${this.slides[this.currentIndex].Title}</em>`;
        }
        return "";
      },

      slideCaption() {
        if (!this.isLoading) {
          return this.slides[this.currentIndex].Asset.Caption;
        }

        return "";
      },

      slideDescription() {
        if (!this.isLoading) {
          return this.slides[this.currentIndex].Description;
        }

        return "";
      },

       slideshowTitle() {
        if (!this.isLoading) {
          return this.title;
        }
        return "";
      },

      currentImage() {
        if (this.isLoading) {
          return "";
        }

        return this.slides[this.currentIndex].Asset.Url;
      },
    },

    methods: {
      fetchSlides: async function () {
        const url = `/slideshows/${this.slideshowId}.json`;
        await fetch(url)
          .then(res => res.json())
          .then(res => {
            this.title = res.Title;
            this.slides = res.Slides;
          })
          .then(res => {
            this.updateHistory();
            this.isLoading= false;
          })
          .catch(error => {
            console.log(url + ' failed with error: ',   error);
          });
      },

      onImgLoad(event) {
        this.height =  Math.round(event.target.height);
        this.width =  Math.round(event.target.width);
        let imageUrl = `https://www.moma.org${this.slides[this.currentIndex].ImageURL}`;
        this.balanceText.balance(this.$el.getElementsByClassName('balance-text'));
        this.$emit('setMetaImage', imageUrl);
        this.imageLoaded = true;
      },

      customReset() {
        //this is needed in case there is a slideshow specific reset need
      },

      updateHistory() {
        const params = new URLSearchParams(location.search);
        params.set("slideshow", this.slideshowId);
        params.set("slide_index", this.currentIndex);

        window.history.replaceState({
          slideIndex: this.currentIndex,
        }, "", `${location.pathname}?${params}`);
      },

      todo() {
        //add transistion for image loading
      }
    }
  };

</script>


